import React, { useState, useEffect } from "react";
import { CheckCircle, Phone, Mail } from "lucide-react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Hero = () => {
  const [contactInfo, setContactInfo] = useState({
    name: "ctb28.fr",
    title: "La tranquillité pour vos travaux",
  phone: "07 65 63 25 84",
    email: "contact@ctb28.fr"
  });

  const [heroContent, setHeroContent] = useState({
    title: "Vos projets, nos conseils pour les concrétiser",
    subtitle: "Consultant en bâtiment avec plus de 40 ans d'expérience, je vous accompagne dans tous vos projets de rénovation, construction et aménagement.",
    description: "Je vous accompagne dans tous vos projets de rénovation, construction et aménagement."
  });

  useEffect(() => {
    const loadContactInfo = async () => {
      try {
        const response = await axios.get(`${API}/public/contact-info`);
        setContactInfo(response.data);
      } catch (error) {
        console.error("Erreur lors du chargement des informations de contact:", error);
      }
    };

    const loadAboutInfo = async () => {
      try {
        const response = await axios.get(`${API}/public/about`);
        if (response.data) {
          setHeroContent({
            title: response.data.hero_title || heroContent.title,
            subtitle: response.data.hero_subtitle || heroContent.subtitle,
            description: response.data.description || heroContent.description
          });
        }
      } catch (error) {
        console.error("Erreur lors du chargement des informations à propos:", error);
      }
    };

    loadContactInfo();
    loadAboutInfo();
  }, []);
  const scrollToContact = () => {
    const element = document.getElementById("contact");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };



  return (
    <main>
  <section id="accueil" className="pt-20 pb-14 relative overflow-hidden">
      {/* Background principal */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-25"
        style={{
          backgroundImage: "url('https://images.unsplash.com/photo-1541888946425-d81bb19240f5?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80')"
        }}
      ></div>
      {/* Overlay dégradé (haut plus clair, bas légèrement teinté) */}
      <div className="absolute inset-0 bg-gradient-to-br from-white/85 via-white/80 to-blue-50/60"></div>
      {/* Motif léger pour donner de la texture (radial gradient) */}
      <div className="pointer-events-none absolute inset-0 opacity-[0.08] mix-blend-multiply" style={{backgroundImage: "radial-gradient(circle at 25% 25%, #0d8c6a 0, transparent 60%)"}}></div>
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-6">
            <div className="space-y-4">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight">
                {heroContent.title}
              </h1>
              <p className="text-xl text-gray-600 leading-relaxed">
                {heroContent.subtitle}
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <button
                onClick={scrollToContact}
                className="bg-blue-900 text-white px-8 py-4 rounded-lg font-semibold hover:bg-blue-800 transform hover:scale-105 transition-all duration-200 shadow-lg hover:shadow-xl"
              >
                Demander un devis gratuit
              </button>
            </div>

            <div className="grid sm:grid-cols-3 gap-6 pt-8">
              <div className="flex items-center space-x-3">
                <CheckCircle className="text-green-600 w-6 h-6" />
                <span className="text-gray-700 font-medium">40+ ans d'expérience</span>
              </div>
              <div className="flex items-center space-x-3">
                <CheckCircle className="text-green-600 w-6 h-6" />
                <span className="text-gray-700 font-medium">100+ projets réalisés</span>
              </div>
              <div className="flex items-center space-x-3">
                <CheckCircle className="text-green-600 w-6 h-6" />
                <span className="text-gray-700 font-medium">Devis rapide</span>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="bg-white/95 backdrop-blur-sm rounded-2xl p-6 md:p-7 shadow-xl border border-gray-100">
              <div className="space-y-5">
                <div className="text-center">
                  <div className="flex items-center justify-center mb-6">
                    <img 
                      src="/ctb28-logo.png" 
                      alt="Logo CTB28 - Conseil & Travaux" 
                      className="h-56 md:h-60 lg:h-64 w-auto drop-shadow-sm transition-transform duration-300"
                      loading="lazy"
                      decoding="async"
                    />
                  </div>
                  <p className="text-blue-900 font-semibold text-center tracking-wide text-sm md:text-base">
                    {contactInfo.title}
                  </p>
                  {/* Badges zones d'intervention déplacés ici */}
                  <div className="mt-3 flex flex-wrap gap-1.5 justify-center">
                    {['Eure-et-Loir (28)', 'Essonne (91)', 'Loiret (45)'].map(zone => (
                      <span key={zone} className="px-2.5 py-0.5 text-[10px] md:text-[11px] rounded-full bg-blue-900/10 text-blue-900 font-medium border border-blue-900/20">
                        {zone}
                      </span>
                    ))}
                  </div>
                </div>
                <div className="h-px bg-gradient-to-r from-transparent via-blue-900/20 to-transparent"></div>
                
                <div className="space-y-4 text-center">
                  <div className="flex items-center justify-center space-x-3 p-2.5 bg-gray-50 rounded-lg">
                    <Phone className="text-blue-900 w-5 h-5" />
                    <span className="text-gray-700">{contactInfo.phone}</span>
                  </div>
                  <div className="flex items-center justify-center space-x-3 p-2.5 bg-gray-50 rounded-lg">
                    <Mail className="text-blue-900 w-5 h-5" />
                    <span className="text-gray-700">{contactInfo.email}</span>
                  </div>
                  {/* Légende retirée à la demande: Réponse sous 24h */}
                </div>

                <div className="text-center pt-4">
                  <button
                    onClick={scrollToContact}
                    className="w-full bg-blue-900 text-white py-3 rounded-lg font-semibold hover:bg-blue-800 transition-colors duration-200 text-sm md:text-base"
                  >
                    Contactez-moi
                  </button>
                </div>
              </div>
            </div>
            
            {/* Decorative elements */}
            <div className="absolute -top-4 -right-4 w-24 h-24 bg-gradient-to-br from-blue-200 to-teal-200 rounded-full opacity-30 blur-sm"></div>
            <div className="absolute -bottom-4 -left-4 w-32 h-32 bg-gradient-to-tr from-blue-100 to-teal-100 rounded-full opacity-25 blur-[2px]"></div>
          </div>
        </div>
      </div>
    </section>
    </main>
  );
};

export default Hero;